import { useSetFilterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';
import { getFacetConditionValues } from '@/features/analyze/lib/facetConditionUtils';
import { FacetKey } from '@/features/analyze/types';
import { useTranslation } from 'react-i18next';
import { NodeType } from '@/features/connect-dots/types/cytoscape';
import { useSelectedFilterItems } from '@/features/connect-dots/hooks/useSelectedFilterItems';
import { FilterItemInfo } from '../../types/SelectedFilterItemsContextType';
import { useCallback } from 'react';

export const FilterButtons = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  const { selectedFilterItems: selectedNodes } = useSelectedFilterItems();
  const setFilterCondition = useSetFilterConditionAtom();

  const addExploreResultTagFilter = useCallback(
    (targetFieldKey: FacetKey, value: FilterItemInfo) => {
      setFilterCondition((prev) => {
        const operator = value.mode;
        const prevTarget = getFacetConditionValues(
          targetFieldKey,
          operator,
          prev
        );

        if (prevTarget.includes(value.name)) return prev;

        return {
          ...prev,
          [targetFieldKey]: {
            ...prev[targetFieldKey],
            [operator]: [...prevTarget, value.name],
          },
        };
      });
    },
    [setFilterCondition]
  );

  // フィルタを適用するためのハンドラ
  const handleApplyFilters = () => {
    // ここでフィルタを適用するロジックを実装
    selectedNodes.forEach((node) => {
      // ノードごとにフィルタを適用する処理を実装
      switch (node.nodeType) {
        case NodeType.THEME:
          addExploreResultTagFilter('themes', node);
          break;
        case NodeType.ASSIST:
        case NodeType.CROSS:
        case NodeType.CROSS_ISSUE:
        case NodeType.NORMAL:
        case NodeType.SOCIAL_ISSUE:
          addExploreResultTagFilter('topicTags', node);
          break;
      }
    });

    onClose();
  };

  // クローズ処理
  const handleClose = () => {
    onClose();
  };

  return (
    <div className="gap-2">
      <button
        onClick={handleApplyFilters}
        className="m-2 rounded bg-rw-sub px-4 py-2 text-white hover:opacity-80"
      >
        {t('適用')}
      </button>
      <button
        onClick={handleClose}
        className="m-2 rounded border border-rw-light-gray px-4 py-2 text-black hover:opacity-80"
      >
        {t('もどる')}
      </button>
    </div>
  );
};
